export const METRIKA_COUNTER_ID = 112397313

export const METRIKA_GOALS = {
  registration: "registration",
  characterCompleted: "character_completed",
  roomEntered: "room_entered",
  focusStarted: "focus_started",
  itemPurchased: "item_purchased",
  personalRoomEntered: "personal_room_entered",
  inviteLinkCopied: "invite_link_copied",
} as const

type GoalId = (typeof METRIKA_GOALS)[keyof typeof METRIKA_GOALS]
type GoalParams = Record<string, string | number | boolean>

declare global {
  interface Window {
    ym?: (...args: unknown[]) => unknown
  }
}

export function reachMetrikaGoal(goal: GoalId, params?: GoalParams) {
  if (typeof window === "undefined" || typeof window.ym !== "function") return
  try {
    window.ym(METRIKA_COUNTER_ID, "reachGoal", goal, params)
  } catch {
    // Analytics must never interrupt the product action it observes.
  }
}
